import { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  INFO_PANE_PAGES,
  openInfoPane,
} from '../../../../redux_store';
import { useTheme } from '@material-ui/core';
import AssessmentOutlinedIcon from '@material-ui/icons/AssessmentOutlined';
import BaseMenuItem from '../../../Shared/Table/widgets/TopBar/MenuItem/BaseMenuItem';

const MetricsButton = memo(({ aggregations, filter, title }) => {
  const theme = useTheme();
  const { currentPage } = useSelector((state) => state.infoPane);
  const { en: { btn } } = useSelector((state) => state.i18n);
  const dispatch = useDispatch();

  useEffect(() => {
    const isNewPage = title !== currentPage?.currentPageContext?.title;
    const wasFiltersUpdated =
      JSON.stringify(currentPage?.currentPageContext?.filter) !== JSON.stringify(filter);
    const wasAggregationsUpdated =
      JSON.stringify(currentPage?.currentPageContext?.aggregations) !== JSON.stringify(aggregations);
    const isMetricsOpened = currentPage?.currentPageName === INFO_PANE_PAGES.metrics;

    if (aggregations
      && Object.keys(aggregations).length
      && isMetricsOpened
      && (isNewPage || wasFiltersUpdated || wasAggregationsUpdated)) {
      dispatch(openInfoPane({
        currentPageName: INFO_PANE_PAGES.metrics,
        currentPageContext: { aggregations, filter, title },
      }));
    }
  }, [aggregations, filter, title]);

  return <BaseMenuItem
    icon={<AssessmentOutlinedIcon style={{
      height: 26,
      width: 26,
      color: theme.palette.primary.main,
    }} />}
    label={btn.metrics}
    onClick={() => {
      if (aggregations && JSON.stringify(currentPage?.currentPageContext?.filter) !== JSON.stringify(filter)) {
        dispatch(openInfoPane({
          currentPageName: INFO_PANE_PAGES.metrics,
          currentPageContext: { title: title, aggregations: aggregations, filter: filter },
        }));
      }
    }}
    isLoading={!aggregations}
    buttonAlign={'flex-start'}
  />;
});

export default MetricsButton;
